import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import CollectionItem from "./item";
import { section } from "../../../actions/surveys";
import { connect } from "react-redux";
import Section from "../../section/item";
import ConditionalButton from "../../conditional-button";
import { deepEqual } from "../../../utils/object";

export class Collection extends React.Component {
    constructor(props) {
        super(props);
        const display = {
            collection: Boolean(props.display?.collection),
            editor: Boolean(props.display?.editor),
        };
        display.collection = !display.editor;

        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? [],
            label: props.label,
            locked: Boolean(props.locked),
            detail: props.detail,
            meta: props.meta,
            display
        }
        this.ref = React.createRef();
    }

    fetchData = async () => {
        if (this.props.detailSection) {
            this.setState({ section: this.props.detailSection });
            return;
        }
        const section = await this.props.section(this.state.detail);
        this.setState({
            section
        })
    }
    
    componentDidMount = () => {
        this.fetchData();
    }

    componentDidUpdate = (oldProps) => {
        const nextState = {};
        let shouldFetchData = false;

        if (oldProps.label !== this.props.label) {
            nextState.label = this.props.label;
        }

        if (!deepEqual(oldProps.meta, this.props.meta)) {
            nextState.meta = this.props.meta || {};
            nextState.configuration = { ...(this.props.meta || {}) };
        }

        if (this.props.display !== oldProps.display) {
            const display = { ...this.props.display };
            display.collection = !display.editor;

            nextState.display = display;
            shouldFetchData = Boolean(display.editor);
        }

        if (!deepEqual(oldProps.data, this.props.data)) {
            const data = this.props.data ?? [];
            if (!deepEqual(this.state.data, data)) {
                nextState.data = data;
            }
        }

        if (Object.keys(nextState).length) {
            this.setState(nextState, () => {
                if (shouldFetchData) this.fetchData();
            });
        } else if (shouldFetchData) {
            this.fetchData();
        }
    }

    getData = () => {
        return this.state.data;
    }

    onOpen = (e, index) => {
        this.setState({
            working: {
                index,
                item: { ...this.state.data[index] }
            },
            display: { editor: true, collection: false }
        });
        this.fetchData();
    }

    onNew = (e) => {
        this.setState({
            working: {
                index: -1,
                item: {}
            },
            display: { editor: true, collection: false }
        }, this.fetchData);
    }

    onItemChange = () => {
        // Create new reference for working item
        if (this.ref.current) {
            const item = this.ref.current.getData();

            if (item === this.state.working.item) return;

            this.setState({
                working: {
                    ...this.state.working,
                    item
                }
            });
        }
    }

    onSaveItemAndReturn = (e) => {
        // Get current data from the section editor
        let itemData = this.state.working.item;
        if (this.ref.current) {
            itemData = this.ref.current.getData();
        }

        const data = [...this.state.data];
        
        if (this.state.working.index === -1) {
            // Adding new item
            data.push(itemData);
        } else {
            // Updating existing item
            data[this.state.working.index] = itemData;
        }
        
        this.setState({
            data,
            working: { index: -1, item: {} },
            display: { editor: false, collection: true }
        }, () => {
            // Notify parent that data changed
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    onCloseItem = (e) => {
        this.setState({
            display: { editor: false, collection: true }
        });
    }

    onDeleteItem = (index) => {
        const data = [...this.state.data];
        data.splice(index, 1);
        this.setState({
            data
        }, () => {
            // Notify parent that data changed
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    calculateTitle = (item) => {
        if (this.props.allowDynamicDisplay === false) {
            return item?.title || item?.name || "Response item";
        }
        if (!!this.state.meta.options.onTitle) {
            // eslint-disable-next-line
            const func = new Function(`return (${this.state.meta.options.onTitle})`)();
            return func(item);
        }
    }

    calculateText = (item) => {
        if (this.props.allowDynamicDisplay === false) return "";
        if (!!this.state.meta.options.onText) {
            // eslint-disable-next-line
            const func = new Function(`return (${this.state.meta.options.onText})`)();
            return func(item);
        }
    }

    calculateIcon = (item) => {
        if (this.props.allowDynamicDisplay === false) return null;
        if (!!this.state.meta.options.onIcon) {
            // eslint-disable-next-line
            const func = new Function(`return (${this.state.meta.options.onIcon})`)();
            return func(item);
        }
    }
    
    calculateIconColor = (item) => {
        if (this.props.allowDynamicDisplay === false) return null;
        if (!!this.state.meta.options.onIconColor) {
            // eslint-disable-next-line
            const func = new Function(`return (${this.state.meta.options.onIconColor})`)();
            return func(item);
        }
    }

    render() {
        return (
            <>
                {this.state.display.collection ? (
                    <>
                        {this.state.label ? (
                            <Row className="g-3">
                                <Col lg="12">
                                    <h2 className="small-title">{this.state.label}</h2>
                                </Col>
                            </Row>
                        ) : null}
                        <Row>
                            <Col>
                                <Card body className="mb-5" style={{ backgroundColor: "transparent", border: "2px solid silver" }}>
                                    <Row>
                                        {this.state?.data?.map((item, index) => (
                                            <CollectionItem
                                                {...item}
                                                key={`${this.props.element}_${index}`}
                                                position="topRight"
                                                title={this.calculateTitle(item)}
                                                image={this.calculateIcon(item)}
                                                imageColor={this.calculateIconColor(item)}
                                                text={this.calculateText(item)}
                                                index={index}
                                                total={this.state.data.length || 0}
                                                actions={[
                                                    {
                                                        image: "iapp-Trash-Bin1",
                                                        label: "delete",
                                                        onClick: (e) => this.onDeleteItem(index)
                                                    }
                                                ]}
                                                onOpen={(e) => this.onOpen(e, index)}
                                            />
                                        ))}
                                        {!this.state.locked && (
                                            <CollectionItem image={"iapp-Plus"} title="new" onOpen={this.onNew} />
                                        )}
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <>
                        <Row className="g-2 justify-content-end">
                            <Col xs={12} sm={6} md={4} lg="auto">
                                <ConditionalButton
                                    className="mb-3 w-100"
                                    enabled={true}
                                    display={true}
                                    onEnabledClick={this.onSaveItemAndReturn}
                                    children={<>Save and Return</>}
                                />
                            </Col>
                            <Col xs={12} sm={6} md={4} lg="auto">
                                <ConditionalButton
                                    className="mb-3 w-100"
                                    enabled={true}
                                    display={true}
                                    onEnabledClick={this.onCloseItem}
                                    children={<>Cancel and Return</>}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Section
                                    ref={this.ref}
                                    active={true}
                                    data={this.state.working?.item || {}}
                                    Questions={this.state.section?.Questions}
                                    onChange={this.onItemChange}
                                    allowDynamicDisplay={this.props.allowDynamicDisplay}
                                    collectionSections={this.props.collectionSections}
                                    richTextLabels={this.props.richTextLabels}
                                />
                            </Col>
                        </Row>
                    </>
                )}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return ({});
};

export default connect(mapStateToProps, { section }, null, { forwardRef: true } )(Collection);
